export const FETCH_EMPLOYEE_REQUEST_APPROVALS =
  "FETCH_EMPLOYEE_REQUEST_APPROVALS";
export const EDIT_EMPLOYEE_REQUEST_APPROVAL = "EDIT_EMPLOYEE_REQUEST_APPROVAL";
